// Quotation Draft Stage related codes goes here

// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import { ExportDownloadBtns } from "../QuotationTopBarBtns";

// Declarations

export default function QuotationDownloadOption(props) {
  return (
    <Fragment>
      <div className="document-meta">
        <div
          data-test="quotationtopbarbtns-document-meta"
          className="document-btns">
          <ExportDownloadBtns {...props} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationStages/QuotationDownloadOption.js